import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Form, ListGroup, Row, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import ModalMapeoCSV from './ModalMapeoCSV';

const ConciliarFacturas = () => {

    //AUTENTICACION
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**FILTROS GENERALES */
    const [rfcSeleccionado, setRfcSeleccionado] = useState('');
    const [listaRfcs, setListaRfcs] = useState([]);

    /**FILTROS */
    const [periodoEstadoCuenta, setPeriodoEstadoCuenta] = useState(new Date());
    const [periodoFacturas, setPeriodoFacturas] = useState(new Date());
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [moneda, setMoneda] = useState('');
    const [tipoMovimiento, setTipoMovimiento] = useState('');

    // Estado de cuenta
    const [movimientosBancarios, setMovimientosBancarios] = useState([]);
    const [movimientosFiltrados, setMovimientosFiltrados] = useState([]);

    // Facturas
    const [facturas, setFacturas] = useState([]);
    const [facturasFiltradas, setFacturasFiltradas] = useState([]);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);

    const [cargando, setCargando] = useState(false);

    // Modal de mapeo CSV
    const [showModalMapeo, setShowModalMapeo] = useState(false);
    const [datosCSV, setDatosCSV] = useState({ headers: [], rows: [] });
    const [mapeoColumnas, setMapeoColumnas] = useState({
        identificador: '',
        fecha: '',
        descripcion: '',
        monto: '',
        tipo: '',
        referencia: '',
        moneda: '',
        tipoCambio: ''
    });
    const [archivoTemporal, setArchivoTemporal] = useState(null);
    
    // Configuración adicional para el modal
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState('');
    const [tipoMovimientoDefault, setTipoMovimientoDefault] = useState('');

    const navigate = useNavigate();

    /**
     * Se ejecuta la primera vez
     */
    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
        }
        checkPermisos();
        cargarDatosEjemplo();
        cargarCuentasBancarias();
    }, []);

    /**
     * Aplica filtros cuando cambian
     */
    useEffect(() => {
        aplicarFiltrosMovimientos();
    }, [tipoMovimiento, periodoEstadoCuenta, movimientosBancarios, rfcSeleccionado]);

    useEffect(() => {
        aplicarFiltrosFacturas();
    }, [tipoDocumento, moneda, periodoFacturas, facturas, rfcSeleccionado]);

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {
        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                // Permisos verificados
            } else {
                navigate("/");
            }
        }
        else {
            navigate("/");
        }
    }

    /**
     * Carga el catálogo de cuentas bancarias
     */
    const cargarCuentasBancarias = async () => {
        try {
            const response = await fetch("/api/Conciliacion/ObtenerCuentasBancarias", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const resultado = await response.json();
                
                if (resultado.iResponseType === 1) {
                    const cuentas = JSON.parse(resultado.detalles);
                    setCuentasBancarias(cuentas);
                } else {
                    showErrorToast('No se pudieron cargar las cuentas bancarias');
                }
            }
        } catch (error) {
            console.error('Error al cargar cuentas bancarias:', error);
            showErrorToast('Error al cargar cuentas bancarias');
        }
    };

    /**
     * Carga datos de ejemplo para visualización
     */
    const cargarDatosEjemplo = () => {
        // Lista de RFCs de ejemplo
        const rfcsEjemplo = [
            { rfc: 'EAB010101ABC', razonSocial: 'EMPRESA ABC S.A. DE C.V.' },
            { rfc: 'CXY020202XYZ', razonSocial: 'CLIENTE XYZ S.A.' },
            { rfc: 'DIS030303DIS', razonSocial: 'DISTRIBUIDOR 123 S.C.' },
            { rfc: 'EDF040404DEF', razonSocial: 'EMPRESA DEF S.A. DE C.V.' },
            { rfc: 'CAB050505CAB', razonSocial: 'CLIENTE ABC S.A.' },
            { rfc: 'EGH060606GHI', razonSocial: 'EMPRESA GHI S.A. DE C.V.' },
        ];

        // Movimientos bancarios de ejemplo (ahora con RFC asociado)
        const movimientosEjemplo = [
            { id: 1, fecha: '2024-01-15', descripcion: 'TRANSFERENCIA SPEI - EMPRESA ABC', monto: 15840.50, tipo: 'ingreso', referencia: 'REF001234', rfc: 'EAB010101ABC' },
            { id: 2, fecha: '2024-01-16', descripcion: 'TRANSFERENCIA SPEI - CLIENTE XYZ', monto: 23200.00, tipo: 'ingreso', referencia: 'REF001235', rfc: 'CXY020202XYZ' },
            { id: 3, fecha: '2024-01-17', descripcion: 'PAGO SERVICIOS', monto: 1250.00, tipo: 'egreso', referencia: 'REF001236', rfc: 'EAB010101ABC' },
            { id: 4, fecha: '2024-01-18', descripcion: 'TRANSFERENCIA SPEI - DISTRIBUIDOR 123', monto: 8700.00, tipo: 'ingreso', referencia: 'REF001237', rfc: 'DIS030303DIS' },
            { id: 5, fecha: '2024-01-19', descripcion: 'COMISIÓN BANCARIA', monto: 85.50, tipo: 'egreso', referencia: 'REF001238', rfc: 'EDF040404DEF' },
            { id: 6, fecha: '2024-01-20', descripcion: 'TRANSFERENCIA SPEI - EMPRESA DEF', monto: 34500.00, tipo: 'ingreso', referencia: 'REF001239', rfc: 'EDF040404DEF' },
            { id: 7, fecha: '2024-01-21', descripcion: 'TRANSFERENCIA SPEI - CLIENTE ABC', monto: 12000.00, tipo: 'ingreso', referencia: 'REF001240', rfc: 'CAB050505CAB' },
            { id: 8, fecha: '2024-01-22', descripcion: 'PAGO PROVEEDORES', monto: 5600.00, tipo: 'egreso', referencia: 'REF001241', rfc: 'CAB050505CAB' },
        ];

        // Facturas de ejemplo
        const facturasEjemplo = [
            {
                id: 1,
                folio: 'F-2024-001',
                receptor: 'EMPRESA ABC S.A. DE C.V.',
                rfc: 'EAB010101ABC',
                total: 15840.50,
                moneda: 'MXN',
                tipoCambio: 1.00,
                tipo: 'PPD',
                fecha: '2024-01-15',
                estatus: 'pendiente'
            },
            {
                id: 2,
                folio: 'F-2024-002',
                receptor: 'CLIENTE XYZ S.A.',
                rfc: 'CXY020202XYZ',
                total: 23200.00,
                moneda: 'MXN',
                tipoCambio: 1.00,
                tipo: 'PUE',
                fecha: '2024-01-16',
                estatus: 'pendiente'
            },
            {
                id: 3,
                folio: 'F-2024-003',
                receptor: 'DISTRIBUIDOR 123 S.C.',
                rfc: 'DIS030303DIS',
                total: 8700.00,
                moneda: 'MXN',
                tipoCambio: 1.00,
                tipo: 'PPD',
                fecha: '2024-01-18',
                estatus: 'pendiente'
            },
            {
                id: 4,
                folio: 'F-2024-004',
                receptor: 'EMPRESA DEF S.A. DE C.V.',
                rfc: 'EDF040404DEF',
                total: 2000.00,
                moneda: 'USD',
                tipoCambio: 17.25,
                tipo: 'PUE',
                fecha: '2024-01-20',
                estatus: 'pendiente'
            },
            {
                id: 5,
                folio: 'F-2024-005',
                receptor: 'CLIENTE ABC S.A.',
                rfc: 'CAB050505CAB',
                total: 12000.00,
                moneda: 'MXN',
                tipoCambio: 1.00,
                tipo: 'PPD',
                fecha: '2024-01-21',
                estatus: 'pendiente'
            },
            {
                id: 6,
                folio: 'F-2024-006',
                receptor: 'EMPRESA GHI S.A. DE C.V.',
                rfc: 'EGH060606GHI',
                total: 1500.00,
                moneda: 'USD',
                tipoCambio: 17.30,
                tipo: 'PUE',
                fecha: '2024-01-22',
                estatus: 'pendiente'
            },
        ];

        setListaRfcs(rfcsEjemplo);
        setMovimientosBancarios(movimientosEjemplo);
        setMovimientosFiltrados(movimientosEjemplo);
        setFacturas(facturasEjemplo);
        setFacturasFiltradas(facturasEjemplo);
    };

    /**
     * Aplica filtros a los movimientos bancarios
     */
    const aplicarFiltrosMovimientos = () => {
        let movimientosFiltrados = [...movimientosBancarios];

        // Filtrar por RFC
        if (rfcSeleccionado) {
            movimientosFiltrados = movimientosFiltrados.filter(m => m.rfc === rfcSeleccionado);
        }

        if (tipoMovimiento) {
            movimientosFiltrados = movimientosFiltrados.filter(m => m.tipo === tipoMovimiento);
        }

        // Filtrar por período mensual
        const mesSeleccionado = periodoEstadoCuenta.getMonth();
        const anioSeleccionado = periodoEstadoCuenta.getFullYear();
        movimientosFiltrados = movimientosFiltrados.filter(m => {
            const fechaMovimiento = new Date(m.fecha);
            return fechaMovimiento.getMonth() === mesSeleccionado && 
                   fechaMovimiento.getFullYear() === anioSeleccionado;
        });

        setMovimientosFiltrados(movimientosFiltrados);
    };

    /**
     * Aplica filtros a las facturas
     */
    const aplicarFiltrosFacturas = () => {
        let facturasFiltradas = [...facturas];

        // Filtrar por RFC
        if (rfcSeleccionado) {
            facturasFiltradas = facturasFiltradas.filter(f => f.rfc === rfcSeleccionado);
        }

        if (tipoDocumento) {
            facturasFiltradas = facturasFiltradas.filter(f => f.tipo === tipoDocumento);
        }

        if (moneda) {
            facturasFiltradas = facturasFiltradas.filter(f => f.moneda === moneda);
        }

        // Filtrar por período mensual
        const mesSeleccionado = periodoFacturas.getMonth();
        const anioSeleccionado = periodoFacturas.getFullYear();
        facturasFiltradas = facturasFiltradas.filter(f => {
            const fechaFactura = new Date(f.fecha);
            return fechaFactura.getMonth() === mesSeleccionado && 
                   fechaFactura.getFullYear() === anioSeleccionado;
        });

        setFacturasFiltradas(facturasFiltradas);
    };

    /**
     * Limpia todos los filtros
     */
    const limpiarFiltros = () => {
        setRfcSeleccionado('');
        setPeriodoEstadoCuenta(new Date());
        setPeriodoFacturas(new Date());
        setTipoDocumento('');
        setMoneda('');
        setTipoMovimiento('');
    };

    /**
     * Lee y parsea el archivo CSV para mostrar en el modal
     */
    const leerArchivoCSV = (file) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
            try {
                const text = e.target.result;
                const lines = text.split('\n').filter(line => line.trim() !== '');
                
                if (lines.length === 0) {
                    showErrorToast("El archivo CSV está vacío");
                    return;
                }

                // Primera línea son los headers
                const headers = lines[0].split(',').map(h => h.trim());
                
                // Resto son los datos (máximo 5 filas para preview)
                const rows = lines.slice(1, Math.min(6, lines.length)).map(line => {
                    return line.split(',').map(cell => cell.trim());
                });

                setDatosCSV({ headers, rows });
                
                // Intentar mapeo automático inteligente
                const mapeoAuto = mapeoAutomaticoColumnas(headers);
                setMapeoColumnas(mapeoAuto);
                
                setArchivoTemporal(file);
                setShowModalMapeo(true);
            } catch (error) {
                showErrorToast("Error al leer el archivo CSV: " + error.message);
            }
        };

        reader.onerror = () => {
            showErrorToast("Error al leer el archivo");
        };

        reader.readAsText(file, 'UTF-8');
    };

    /**
     * Mapeo automático inteligente de columnas
     */
    const mapeoAutomaticoColumnas = (headers) => {
        const mapeo = {
            identificador: '',
            fecha: '',
            descripcion: '',
            monto: '',
            tipo: '',
            referencia: '',
            moneda: '',
            tipoCambio: ''
        };

        headers.forEach((header, index) => {
            const headerLower = header.toLowerCase();
            
            // Mapeo de identificador
            if (headerLower.includes('id') || headerLower.includes('identificador') || 
                headerLower.includes('folio') || headerLower.includes('numero')) {
                mapeo.identificador = index.toString();
            }
            
            // Mapeo de fecha
            if (headerLower.includes('fecha') || headerLower.includes('date')) {
                mapeo.fecha = index.toString();
            }
            
            // Mapeo de descripción
            if (headerLower.includes('descripcion') || headerLower.includes('concepto') || 
                headerLower.includes('description') || headerLower.includes('detalle')) {
                mapeo.descripcion = index.toString();
            }
            
            // Mapeo de monto
            if (headerLower.includes('monto') || headerLower.includes('importe') || 
                headerLower.includes('amount') || headerLower.includes('total')) {
                mapeo.monto = index.toString();
            }
            
            // Mapeo de tipo
            if (headerLower.includes('tipo') || headerLower.includes('type') || 
                headerLower.includes('movimiento') || headerLower.includes('cargo') || 
                headerLower.includes('abono')) {
                mapeo.tipo = index.toString();
            }
            
            // Mapeo de referencia
            if (headerLower.includes('referencia') || headerLower.includes('reference') || 
                headerLower.includes('ref')) {
                mapeo.referencia = index.toString();
            }
            
            // Mapeo de moneda
            if (headerLower.includes('moneda') || headerLower.includes('currency') || 
                headerLower.includes('divisa')) {
                mapeo.moneda = index.toString();
            }
            
            // Mapeo de tipo de cambio
            if ((headerLower.includes('tipo') && headerLower.includes('cambio')) || 
                headerLower.includes('tipocambio') || headerLower.includes('tc') ||
                headerLower.includes('exchange')) {
                mapeo.tipoCambio = index.toString();
            }
        });

        return mapeo;
    };

    /**
     * Maneja la selección inicial del archivo
     */
    const handleSeleccionarArchivo = (e) => {
        const file = e.target.files[0];
        
        if (!file) {
            return;
        }

        if (!rfcSeleccionado) {
            showErrorToast("Debe seleccionar un RFC antes de importar");
            e.target.value = '';
            return;
        }

        // Validar extensión
        const extension = file.name.split('.').pop().toLowerCase();
        if (extension !== 'csv') {
            showErrorToast("Solo se permiten archivos CSV");
            e.target.value = '';
            return;
        }

        // Validar tamaño (5MB máximo)
        if (file.size > 5 * 1024 * 1024) {
            showErrorToast("El archivo no debe superar los 5MB");
            e.target.value = '';
            return;
        }

        // Leer y mostrar modal de mapeo
        leerArchivoCSV(file);
        
        // Limpiar el input
        e.target.value = '';
    };

    /**
     * Confirma el mapeo y procesa la importación
     */
    const confirmarImportacion = async () => {
        // Validar que todos los campos obligatorios estén mapeados
        const camposObligatorios = ['identificador', 'fecha', 'descripcion', 'monto', 'referencia'];
        const camposFaltantes = camposObligatorios.filter(campo => !mapeoColumnas[campo]);
        
        if (camposFaltantes.length > 0) {
            showErrorToast(`Debe mapear los siguientes campos obligatorios: ${camposFaltantes.join(', ')}`);
            return;
        }

        try {
            setCargando(true);
            setShowModalMapeo(false);

            const formData = new FormData();
            formData.append('file', archivoTemporal);
            formData.append('rfcEmisor', rfcSeleccionado);
            formData.append('idCatCuentaBancaria', cuentaSeleccionada);
            formData.append('tipoMovimientoDefault', tipoMovimientoDefault);
            formData.append('mapeoColumnas', JSON.stringify(mapeoColumnas));

            const response = await fetch('/api/Conciliacion/ImportarEstadoCuenta', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: formData
            });

            if (response.ok) {
                const resultado = await response.json();
                
                if (resultado.iResponseType === 1) {
                    showSuccessToast(resultado.vMessage);
                    // Recargar los movimientos bancarios
                    aplicarFiltrosMovimientos();
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error al importar: ${response.status} ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error al importar estado de cuenta:', error);
            showErrorToast('Error al procesar el archivo: ' + error.message);
        } finally {
            setCargando(false);
            setArchivoTemporal(null);
            setCuentaSeleccionada('');
            setTipoMovimientoDefault('');
        }
    };

    /**
     * Cancela el modal de mapeo
     */
    const cancelarMapeo = () => {
        setShowModalMapeo(false);
        setArchivoTemporal(null);
        setDatosCSV({ headers: [], rows: [] });
        setMapeoColumnas({
            identificador: '',
            fecha: '',
            descripcion: '',
            monto: '',
            tipo: '',
            referencia: '',
            moneda: '',
            tipoCambio: ''
        });
        setCuentaSeleccionada('');
        setTipoMovimientoDefault('');
    };

    /**
     * Calcula totales de movimientos bancarios
     */
    const calcularTotales = () => {
        const ingresos = movimientosFiltrados
            .filter(m => m.tipo === 'ingreso')
            .reduce((sum, m) => sum + m.monto, 0);

        const egresos = movimientosFiltrados
            .filter(m => m.tipo === 'egreso')
            .reduce((sum, m) => sum + m.monto, 0);

        return { ingresos, egresos, neto: ingresos - egresos };
    };

    const totales = calcularTotales();

    /**
     * Obtiene información del RFC seleccionado
     */
    const getRfcInfo = () => {
        if (!rfcSeleccionado) return null;
        return listaRfcs.find(r => r.rfc === rfcSeleccionado);
    };

    const rfcInfo = getRfcInfo();



    return (
        <>
            {/* Header */}
            <Card className="mb-3">
                <Card.Body className="p-3">
                    <Row className="align-items-center">
                        <Col xs="auto">
                            <div className="bg-soft-primary rounded-3 p-2">
                                <img src="/img/ordenes96.png" alt="conciliación" height={40} />
                            </div>
                        </Col>
                        <Col>
                            <h4 className="mb-0 text-primary">
                                Conciliación de Facturas
                            </h4>
                            <p className="text-600 fs--1 mb-0">
                                Concilie sus facturas con los movimientos del estado de cuenta bancario
                            </p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Filtro General de RFC */}
            <Card className="mb-3 shadow-sm">
                <Card.Body className="p-3">
                    <Row className="align-items-center g-3">
                        <Col md={6} lg={5}>
                            <Form.Group>
                                <Form.Label className="text-700 fw-bold fs--1 mb-2">
                                    <i className="fas fa-id-card me-2 text-primary"></i>
                                    RFC del Contribuyente
                                </Form.Label>
                                <Form.Select
                                    value={rfcSeleccionado}
                                    onChange={(e) => setRfcSeleccionado(e.target.value)}
                                    className="form-control"
                                    style={{ fontSize: '0.9rem' }}
                                >
                                    <option value="">Seleccione un RFC</option>
                                    {listaRfcs.map((item, index) => (
                                        <option key={index} value={item.rfc}>
                                            {item.rfc} - {item.razonSocial}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        {rfcInfo && (
                            <Col md={6} lg={5}>
                                <div className="bg-light rounded p-3 h-100">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-primary rounded-circle p-2 me-3" style={{ width: '50px', height: '50px' }}>
                                            <i className="fas fa-building text-white fs-1 d-flex align-items-center justify-content-center"></i>
                                        </div>
                                        <div>
                                            <div className="text-700 fw-bold fs--1 mb-1">
                                                {rfcInfo.razonSocial}
                                            </div>
                                            <div className="text-600 fs--2">
                                                <i className="fas fa-fingerprint me-1"></i>
                                                RFC: <span className="fw-semi-bold">{rfcInfo.rfc}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )}

                        <Col md={12} lg={2} className="text-end">
                            <Button 
                                variant="outline-danger" 
                                size="sm"
                                onClick={limpiarFiltros}
                                disabled={!rfcSeleccionado}
                            >
                                <i className="fas fa-times me-1"></i>
                                Limpiar Todo
                            </Button>
                        </Col>
                    </Row>

                    {!rfcSeleccionado && (
                        <Row className="mt-3">
                            <Col>
                                <div className="alert alert-info mb-0 py-2 fs--1">
                                    <i className="fas fa-info-circle me-2"></i>
                                    Por favor, seleccione un RFC para visualizar los movimientos bancarios y facturas correspondientes.
                                </div>
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>

            {/* Modal de Mapeo de Columnas CSV */}
            <ModalMapeoCSV
                show={showModalMapeo}
                onHide={cancelarMapeo}
                onConfirm={confirmarImportacion}
                datosCSV={datosCSV}
                mapeoColumnas={mapeoColumnas}
                setMapeoColumnas={setMapeoColumnas}
                cuentasBancarias={cuentasBancarias}
                cuentaSeleccionada={cuentaSeleccionada}
                setCuentaSeleccionada={setCuentaSeleccionada}
                tipoMovimientoDefault={tipoMovimientoDefault}
                setTipoMovimientoDefault={setTipoMovimientoDefault}
            />

            {/* Sección Principal: Estado de Cuenta y Facturas */}
            <Row className="g-3">
                {/* Columna Izquierda: Estado de Cuenta */}
                <Col lg={6}>
                    <Card className="shadow-sm h-100">
                        <Card.Header className="bg-gradient-primary text-white">
                            <Row className="align-items-center">
                                <Col>
                                    <h5 className="mb-0 text-white">
                                        <i className="fas fa-file-invoice-dollar me-2"></i>
                                        Estado de Cuenta Bancario
                                    </h5>
                                </Col>
                                <Col xs="auto">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        onClick={() => document.getElementById('fileInput').click()}
                                        disabled={!rfcSeleccionado || cargando}
                                    >
                                        {cargando ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-1" />
                                                Importando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-upload me-1"></i>
                                                Importar
                                            </>
                                        )}
                                    </Button>
                                    <input
                                        id="fileInput"
                                        type="file"
                                        accept=".csv"
                                        style={{ display: 'none' }}
                                        onChange={handleSeleccionarArchivo}
                                    />
                                </Col>
                            </Row>
                        </Card.Header>

                        {/* Filtros del Estado de Cuenta */}
                        <div className="p-3 bg-light border-bottom">
                            <Row className="g-2 align-items-end">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                                            <i className="far fa-calendar-alt me-1"></i>
                                            Período
                                        </Form.Label>
                                        <DatePicker
                                            selected={periodoEstadoCuenta}
                                            onChange={(date) => setPeriodoEstadoCuenta(date)}
                                            dateFormat="MMMM yyyy"
                                            showMonthYearPicker
                                            className="form-control form-control-sm"
                                            placeholderText="Seleccione mes"
                                            disabled={!rfcSeleccionado}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                                            <i className="fas fa-filter me-1"></i>
                                            Tipo de Movimiento
                                        </Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={tipoMovimiento}
                                            onChange={(e) => setTipoMovimiento(e.target.value)}
                                            className="form-control"
                                            disabled={!rfcSeleccionado}
                                        >
                                            <option value="">Todos</option>
                                            <option value="ingreso">● Ingresos</option>
                                            <option value="egreso">● Egresos</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>

                        <Card.Body className="p-0">
                            {/* Resumen de Totales */}
                            <div className="p-3 bg-light border-bottom">
                                <Row className="g-2">
                                    <Col xs={4}>
                                        <div className="text-center p-2 bg-white rounded shadow-sm">
                                            <div className="text-success fs--2 fw-semi-bold">INGRESOS</div>
                                            <div className="text-success fs-0 fw-bold">
                                                ${totales.ingresos.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={4}>
                                        <div className="text-center p-2 bg-white rounded shadow-sm">
                                            <div className="text-danger fs--2 fw-semi-bold">EGRESOS</div>
                                            <div className="text-danger fs-0 fw-bold">
                                                ${totales.egresos.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={4}>
                                        <div className="text-center p-2 bg-white rounded shadow-sm">
                                            <div className="text-primary fs--2 fw-semi-bold">NETO</div>
                                            <div className="text-primary fs-0 fw-bold">
                                                ${totales.neto.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Lista de Movimientos */}
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <ListGroup variant="flush">
                                    {!rfcSeleccionado ? (
                                        <ListGroup.Item className="text-center text-600 py-5">
                                            <i className="fas fa-exclamation-triangle fa-2x mb-3 text-warning"></i>
                                            <p className="mb-0">Seleccione un RFC para ver los movimientos</p>
                                        </ListGroup.Item>
                                    ) : movimientosFiltrados.length > 0 ? (
                                        movimientosFiltrados.map((movimiento) => (
                                            <ListGroup.Item
                                                key={movimiento.id}
                                                className="border-start border-4 hover-shadow transition-base"
                                                style={{
                                                    borderColor: movimiento.tipo === 'ingreso' ? '#28a745' : '#dc3545',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <Row className="align-items-center">
                                                    <Col xs={2} className="text-center">
                                                        <div
                                                            className={`rounded-circle d-inline-flex align-items-center justify-content-center`}
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                backgroundColor: movimiento.tipo === 'ingreso' ? '#d4edda' : '#f8d7da'
                                                            }}
                                                        >
                                                            <i
                                                                className={`fas ${movimiento.tipo === 'ingreso' ? 'fa-arrow-down text-success' : 'fa-arrow-up text-danger'}`}
                                                            ></i>
                                                        </div>
                                                    </Col>
                                                    <Col xs={7}>
                                                        <div className="fw-semi-bold text-800 fs--1 mb-1">
                                                            {movimiento.descripcion}
                                                        </div>
                                                        <div className="text-600 fs--2">
                                                            <i className="far fa-calendar me-1"></i>
                                                            {movimiento.fecha}
                                                            <span className="mx-2">•</span>
                                                            <i className="fas fa-hashtag me-1"></i>
                                                            {movimiento.referencia}
                                                        </div>
                                                    </Col>
                                                    <Col xs={3} className="text-end">
                                                        <div
                                                            className={`fw-bold fs-0 ${movimiento.tipo === 'ingreso' ? 'text-success' : 'text-danger'}`}
                                                        >
                                                            {movimiento.tipo === 'ingreso' ? '+' : '-'}

                                                            ${movimiento.monto.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        ))
                                    ) : (
                                        <ListGroup.Item className="text-center text-600 py-4">
                                            <i className="fas fa-info-circle me-2"></i>
                                            No hay movimientos para el período seleccionado
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Columna Derecha: Facturas */}
                <Col lg={6}>
                    <Card className="shadow-sm h-100">
                        <Card.Header className="bg-gradient-info text-white">
                            <Row className="align-items-center">
                                <Col>
                                    <h5 className="mb-0 text-white">
                                        <i className="fas fa-file-invoice me-2"></i>
                                        Facturas por Conciliar
                                    </h5>
                                </Col>
                                <Col xs="auto">
                                    <Badge bg="light" text="dark" className="fs--1">
                                        {facturasFiltradas.length} facturas
                                    </Badge>
                                </Col>
                            </Row>
                        </Card.Header>

                        {/* Filtros de Facturas */}
                        <div className="p-3 bg-light border-bottom">
                            <Row className="g-2">
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                                            <i className="far fa-calendar-alt me-1"></i>
                                            Período
                                        </Form.Label>
                                        <DatePicker
                                            selected={periodoFacturas}
                                            onChange={(date) => setPeriodoFacturas(date)}
                                            dateFormat="MMMM yyyy"
                                            showMonthYearPicker
                                            className="form-control form-control-sm"
                                            placeholderText="Seleccione mes"
                                            disabled={!rfcSeleccionado}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                                            <i className="fas fa-file-alt me-1"></i>
                                            Tipo
                                        </Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={tipoDocumento}
                                            onChange={(e) => setTipoDocumento(e.target.value)}
                                            className="form-control"
                                            disabled={!rfcSeleccionado}
                                        >
                                            <option value="">Todos</option>
                                            <option value="PPD">PPD</option>
                                            <option value="PUE">PUE</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                                            <i className="fas fa-dollar-sign me-1"></i>
                                            Moneda
                                        </Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={moneda}
                                            onChange={(e) => setMoneda(e.target.value)}
                                            className="form-control"
                                            disabled={!rfcSeleccionado}
                                        >
                                            <option value="">Todas</option>
                                            <option value="MXN">MXN</option>
                                            <option value="USD">USD</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>

                        <Card.Body className="p-3" style={{ maxHeight: '550px', overflowY: 'auto' }}>
                            <Row className="g-3">
                                {!rfcSeleccionado ? (
                                    <Col xs={12}>
                                        <div className="text-center text-600 py-5">
                                            <i className="fas fa-exclamation-triangle fa-2x mb-3 text-warning"></i>
                                            <p className="mb-0">Seleccione un RFC para ver las facturas</p>
                                        </div>
                                    </Col>
                                ) : facturasFiltradas.length > 0 ? (
                                    facturasFiltradas.map((factura) => (
                                        <Col xs={12} key={factura.id}>
                                            <Card
                                                className={`shadow-sm hover-shadow transition-base ${facturaSeleccionada?.id === factura.id ? 'border-primary border-2' : ''}`}

                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setFacturaSeleccionada(factura)}
                                            >
                                                <Card.Body className="p-3">
                                                    <Row className="align-items-center mb-2">
                                                        <Col>
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                    className="bg-soft-info rounded p-2 me-2"
                                                                    style={{ width: '40px', height: '40px' }}
                                                                >
                                                                    <i className="fas fa-file-invoice text-info fs-1"></i>
                                                                </div>
                                                                <div>
                                                                    <h6 className="mb-0 text-800">
                                                                        {factura.folio}
                                                                    </h6>
                                                                    <div className="text-600 fs--2">
                                                                        {factura.fecha}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs="auto">
                                                            <Badge
                                                                bg={factura.tipo === 'PPD' ? 'warning' : 'success'}
                                                                className="fs--2"
                                                            >
                                                                {factura.tipo}
                                                            </Badge>
                                                        </Col>
                                                    </Row>

                                                    <div className="mb-2">
                                                        <div className="text-700 fw-semi-bold fs--1 mb-1">
                                                            <i className="fas fa-building me-2 text-600"></i>
                                                            {factura.receptor}
                                                        </div>
                                                        <div className="text-600 fs--2 ms-4">
                                                            RFC: {factura.rfc}
                                                        </div>
                                                    </div>

                                                    <div className="border-top pt-2">
                                                        <Row className="align-items-center">
                                                            <Col>
                                                                <div className="text-600 fs--2 mb-1">Total</div>
                                                                <div className="text-primary fw-bold fs-1">
                                                                    ${factura.total.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                                    <span className="text-600 fs--1 ms-2">{factura.moneda}</span>
                                                                </div>
                                                                {factura.moneda === 'USD' && (
                                                                    <div className="text-600 fs--2">
                                                                        T.C. ${factura.tipoCambio.toFixed(4)} =
                                                                        <span className="text-800 fw-semi-bold ms-1">
                                                                            ${(factura.total * factura.tipoCambio).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </Col>
                                                            <Col xs="auto">
                                                                <Button
                                                                    variant="outline-primary"
                                                                    size="sm"
                                                                    className="rounded-pill"
                                                                >
                                                                    <i className="fas fa-link me-1"></i>
                                                                    Conciliar
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    <Col xs={12}>
                                        <div className="text-center text-600 py-5">
                                            <i className="fas fa-inbox fa-3x mb-3 opacity-25"></i>
                                            <p className="mb-0">No hay facturas para el período seleccionado</p>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ConciliarFacturas;
